import 'vbrick-icon-font/dist/vb-icon-font.css';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { VbrickPlayerModule } from '@vbrick/vbrick-player';
import { FormsModule } from '@angular/forms';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { AngularAppBootstrapDepsModule } from 'rev-shared/bootstrap/AngularAppBootstrapDeps.Module';
import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { EventAccessControl } from 'rev-portal/scheduledEvents/EventAccessControl';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SecurityComponentsModule } from 'rev-shared/security/components/SecurityComponents.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { VbWebcastViewModule } from 'rev-shared/webcast/webcastView/VbWebcastView.Module';

import { AutoLinkModule } from 'rev-shared/ui/autoLink/AutoLink.Module';
import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule, RootDialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';
import { TokenHttpInterceptor } from 'rev-shared/security/TokenHttpInterceptor.Service';
import { ENABLE_TOKEN_SERVICE_INJECTION_TOKEN } from 'rev-shared/security/Token.Provider';

import { ScheduledEventsCommonModule } from 'rev-portal/scheduledEvents/common/ScheduledEventsCommon.AngularModule';

import { AppComponent } from './App.Component';
import { EmbedLoginModule } from '../login/EmbedLogin.Module';
import { EventRegistrationComponent } from 'rev-portal/scheduledEvents/eventRegistration/EventRegistration.Component';
import { EmbedVideoModule } from '../video/EmbedVideo.Module';
import { EmbedWebcastComponent } from './EmbedWebcast.Component';
import { EmbedWebcastLoginComponent } from './EmbedWebcastLogin.Component';
import { configureUiRouter, embedWebcastStates } from './StateDeclarations';
import { WebcastInfoViewComponent } from 'rev-shared/webcast/infoView/WebcastInfoView.Component';

const isPublic = BootstrapContext.accessControl === EventAccessControl.Public;

@NgModule({
	declarations: [
		AppComponent,
		EmbedWebcastComponent,
		EmbedWebcastLoginComponent
	],
	bootstrap: [AppComponent],
	imports: [
		AngularAppBootstrapDepsModule,
		AutoLinkModule,
		BrandingAngularModule,
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		EmbedLoginModule,
		EmbedVideoModule,
		EventRegistrationComponent,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		NgxTrimDirectiveModule,
		PipesAngularModule,
		PushModule.forRoot(true),
		RootDialogAngularModule,
		ScheduledEventsCommonModule,
		SecurityAngularModule,
		SecurityComponentsModule,
		SpinnerAngularModule,
		TextInputAngularModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule,
		VbUiToggleContentDisplayAngularModule,
		VbWebcastViewModule,
		WebcastInfoViewComponent,
		VbrickPlayerModule,

		UIRouterModule.forRoot({
			config: configureUiRouter,
			states: embedWebcastStates,
			initial: { state: 'embed' },
			useHash: true
		})
	],
	providers: [{
		provide: 'UserContextCfg',
		useValue: {
			disableUserContextStore: isPublic,
			enableSessionStorage: isPublic
		}
	}, {
		provide: HTTP_INTERCEPTORS,
		useClass: TokenHttpInterceptor,
		multi: true
	}, {
		provide: ENABLE_TOKEN_SERVICE_INJECTION_TOKEN,
		useValue: true
	}]
})
export class EmbedWebcastModule {
}
